export const PRIMARY = "#2E2C32";
export const SECONDARY = "#2E2C32";

export const OFF_WHITE = "#F8F6FB";

export const GRAY_25 = "#FAFAFA";
export const GRAY_50 = "#E7E7E7";
export const GRAY_100 = "#DEDCE2";
export const GRAY_200 = "#A5A5A5";
export const GRAY_300 = "#717579";
export const GRAY_400 = "#515355";
export const GRAY_800 = "#B6B3B9";

export const RED = "#FF144D";

const colors = {
  PRIMARY,
  SECONDARY,
  GRAY_25,
  GRAY_50,
  GRAY_100,
  GRAY_200,
  GRAY_300,
  GRAY_400,
  GRAY_800,
  RED,
  OFF_WHITE,
};
export default colors;
